// Claves localStorage usadas por el flow passwordless. Namespaced con `mihato.`
// para no colisionar con otras apps.
export const PENDING_EMAIL_KEY = "mihato.pendingLoginEmail";
export const PENDING_INVITATION_TOKEN_KEY = "mihato.pendingInvitationToken";

export function readPendingEmail(): string | null {
  try {
    return window.localStorage.getItem(PENDING_EMAIL_KEY);
  } catch {
    return null;
  }
}

export function writePendingEmail(email: string): void {
  try {
    window.localStorage.setItem(PENDING_EMAIL_KEY, email);
  } catch {
    // swallow: modo incógnito puede bloquear localStorage
  }
}

export function clearPendingEmail(): void {
  try {
    window.localStorage.removeItem(PENDING_EMAIL_KEY);
  } catch {
    // swallow
  }
}

export function readPendingInvitationToken(): string | null {
  try {
    return window.localStorage.getItem(PENDING_INVITATION_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function writePendingInvitationToken(token: string): void {
  try {
    window.localStorage.setItem(PENDING_INVITATION_TOKEN_KEY, token);
  } catch {
    // swallow: incognito can block localStorage
  }
}

export function clearPendingInvitationToken(): void {
  try {
    window.localStorage.removeItem(PENDING_INVITATION_TOKEN_KEY);
  } catch {
    // swallow
  }
}
